
import { Mail, Phone } from "lucide-react";

const AffiliateContact = () => {
  return (
    <div className="text-center mt-12 p-6 bg-primary-light rounded-lg">
      <h3 className="text-xl font-semibold text-primary-dark mb-2">
        Questions About Our Affiliate Program?
      </h3>
      <p className="text-gray-700 mb-4">
        Our affiliate team is here to help you succeed as a partner.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href="mailto:affiliate@nearlabservices.com"
          className="inline-flex items-center gap-2 text-primary-dark hover:underline"
        >
          <Mail className="w-4 h-4" />
          affiliate@nearlabservices.com
        </a>
        <a
          href="tel:7135104442"
          className="inline-flex items-center gap-2 text-primary-dark hover:underline"
        >
          <Phone className="w-4 h-4" />
          7135104442
        </a>
      </div>
    </div>
  );
};

export default AffiliateContact;
